import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { EditDialogColumn } from 'react-md';

import { invokeBackendApi } from '../../libs/awsLib';
import { nameValueReducer } from '../../utils/reducers';
import TooltipFontIcon from '../TooltipFontIcon';

import UsersTab from './UsersTab';

class Psychologists extends React.PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      drivers: [],
    };
  }

  async componentDidMount() {
    this.loadDrivers();
  }

  loadDrivers = () => {
    this.users('driverGroup')
      .then(results =>
        this.setState({ isLoading: false, drivers: results.map(u => ({ ...u, attr: u.Attributes.reduce(nameValueReducer, {}) })) }))
      .catch(e => alert(e));
  }

  users(groupName) {
    return invokeBackendApi({ path: '/users', queryParams: { groupName } });
  }

  render() {
    const { intl, ...childProps } = this.props;
    const { drivers, isLoading } = this.state;

    const props = {
      group: 'psyGroup',
      tabTitle: intl.formatMessage({ id: 'adminDashboard.tabs.psychologists' }),
      displayedAttributes: [
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.firstName' }),
          attributeKey: 'name',
          editor: {
            style: { minWidth: '150px' },
            inline: true,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.lastName' }),
          attributeKey: 'family_name',
          editor: {
            style: { minWidth: '150px' },
            inline: true,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.users.email' }),
          grow: true,
          attributeKey: 'email',
          editor: {
            inline: true,
            updatable: false,
          },
        },
        {
          tableHeader: intl.formatMessage({ id: 'adminDashboard.psychologist.assigned' }),
          attributeKey: 'assigned',
          display: (attributeValue, user) => (<span>{drivers.filter(u => user.attr.sub !== undefined && u.attr['custom:assignedPsy'] === user.attr.sub).length} {intl.formatMessage({ id: 'adminDashboard.psychologist.drivers' })}</span>),
        },
        {
          attributeKey: 'custom:comment',
          editor: {
            id: 'comment_editor',
            large: true,
            maxLength: 200,
            rows: 1,
            maxRows: 6,
            placeholder: intl.formatMessage({ id: 'adminDashboard.users.clickEnterComment' }),
            anchor: {
              x: EditDialogColumn.HorizontalAnchors.INNER_RIGHT,
              y: EditDialogColumn.VerticalAnchors.BOTTOM,
            },
          },
          display: attributeValue => (attributeValue && <TooltipFontIcon tooltipLabel={<div className="myTooltip">{attributeValue}</div>}>comment</TooltipFontIcon>),
        },
      ],
    };
    return !isLoading && <UsersTab {...childProps} {...props} />;
  }
}

export default injectIntl(Psychologists);



// WEBPACK FOOTER //
// ./src/components/Users/Psychologists.js